const dsuCampusLocations = [
    {
        "name": "Martin Luther King Jr. Student Center",
        "description": "Hosts dining options, event spaces, and student services."
    },
    {
        "name": "Loockerman Hall",
        "description": "A National Historic Landmark and one of the oldest buildings on campus."
    },
    {
        "name": "William C. Jason Library",
        "description": "The main library providing academic resources and study spaces."
    },
    {
        "name": "Bank of America Building",
        "description": "Houses classrooms and academic departments."
    },
    {
        "name": "Education and Humanities Building",
        "description": "Contains classrooms and offices for education and humanities departments."
    },
    {
        "name": "Luna I. Mishoe Science Center",
        "description": "Comprises the North and South sections, hosting science laboratories and classrooms."
    },
    {
        "name": "University Village Apartments",
        "description": "Student housing complex with multiple buildings and a café."
    },
    {
        "name": "Courtyard Apartments",
        "description": "Residential housing offering apartment-style living for students."
    },
    {
        "name": "Conrad Hall",
        "description": "Academic building with classrooms and faculty offices."
    }
];

export default dsuCampusLocations;